<template>
    <!-- 拼图多选模式底部弹窗按钮 -->
    <div v-if="visible" class="multipleChoseModal toast-chose" :style="albumDetail.discount?'height:95px':''">
        <div style="display: flex; flex-direction: column; width: 100%">
            <div v-if="albumDetail.discount" class="discountTip">提示：一次性购买满{{ albumDetail.discountPhotoCount }}张享{{ albumDetail.discountProportion / 10 }}折优惠</div>
            <div class="multipleContainer">
                <div @click="closeChose">取消</div>
                <div v-if="choseType == 'PUZZLE'" @click="confirmPluzze" class="confirmBtn toast-chose-btn">确定({{ chosePhotoCount }}/9)</div>
                <div v-if="choseType == 'BUY'">
                    <div style="display: flex; align-items: center">
                        <div style="display: flex; flex-direction: column">
                            <div class="album-title">
                                <span style="font-size: 11px">合计：￥</span>
                                <span style="font-size: 16px">{{ payMoney }}</span>
                            </div>
                            <div v-if="discountMoney > 0" style="color: #ff782d; font-size: 11px">已为您优惠{{ discountMoney }}元</div>
                        </div>
                        <div @click="confirmBuy" class="confirmBtn toast-chose-btn" style="margin-left: 10px">立即支付</div>
                    </div>
                </div>
                <div v-if="choseType == 'DOWNLOAD'" @click="downloadMini" class="confirmBtn toast-chose-btn">立即下载({{ chosePhotoCount }})</div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from 'vue';
const emit = defineEmits(['closeChose','confirmPluzze','confirmBuy','downloadMini'])
const props = defineProps({
    choseType: {
        type: String,
        default: ''
    },
    visible: {
        type: Boolean,
        default:false
    },
    albumDetail: {
        type: Object,
        default: () => ({})
    },
    chosePhotoCount: {
        type: Number,
        default: 0
    },
    payMoney: {
        type: Number,
        default: 0
    },
    discountMoney: {
        type: Number,
        default: 0
    }
}) 

const closeChose = () => {
    emit('closeChose')
}
const confirmPluzze = () => {
    emit('confirmPluzze')
}
const confirmBuy = () => {
    emit('confirmBuy')
}
const downloadMini = () => {
    emit('downloadMini')
}
</script>

<style scope>
.multipleChoseModal {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    display: flex;
}
.multipleContainer {
    width: 100%;
    padding: 0 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 14px 15px;
}
.discountTip {
    width: 100%;
    background: #fff4d9;
    font-size: 14px;
    color: #ff782d;
    padding: 5px 15px;
}
.confirmBtn {
    min-width: 123px;
    height: 32px;
    border-radius: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px 20px;
}
</style>